import React, { useEffect, useState, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import '../../components/common/style.css';
import '../../components/common/responsive.css';
import './media_sell_now_sub_categories.css';
import dropdownImage from '../../assets/images/expand_more.png';
import banner_pro_detail_2 from '../../assets/images/banner_pro_detail_2.jpg';
import cartIcon from '../../assets/images/cart_icon-2.png';
import Header from '../../components/common/header';
import Footer from '../../components/common/footer';
import { decryptData, useUser } from '../../contexts/userContext';
import { useCart } from '../../contexts/cartContext';
import productImage from '../../assets/images/Frame 20.png';
import CityPopup from '../../components/common/cityPopup';
import Login from '../login/loginPage';
import PopupLogin from './popupLoginPage';
import { Modal } from 'bootstrap';
import SEOContent from '../../components/common/seoContentPage';
import { useRefresh } from '../../contexts/refreshLogin';

interface Brand {
  title: string;
}

interface ChildPro {
  title: string;
  cat_id: string;
  parent_cat_id: string;
}

interface Category {
  title: string;
  listing_banner: string;
  slug: string;
  logo_img: string;
  mobile_listing_banner: string;
}

interface Attribute {
  attribute_id: number;
  title: string;
  values: { id: number; value: string }[];
}

interface ApiResponse {
  data: {
    data: Attribute[];
  };
}

interface AttributeValue {
  id: number | string;
  value: string;
}

interface FlashMessageProps {
  message: string;
  onClose: () => void;
}

const ProductDetailPageSame: React.FC<{ category?: any }> = ({ category }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const [seoContent, setSeoContent] = useState<string | null>(null);
  const [isButtonClicked, setIsButtonClicked] = useState(false);
  const [loading, setLoading] = useState<boolean>(true);
  const [buttonName, setButtonName] = useState<string>('Login');
  const [isPopupVisible, setIsPopupVisible] = useState(false);
  const [showAddModal, setshowAddModal] = useState(false);
  const [showAddModalNotExist, setShowModalNotExist] = useState(false);
  const [childPro, setChildPro] = useState<ChildPro[]>([]);
  const [selectedchildPro, setselectedchildPro] = useState<string | null>(null);
  const [titleName, settitleName] = useState<string | null>(null);
  const [defaultBanner, setdefaultBanner] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState(false);
  const [cityName, setCityName] = useState<string | null>(sessionStorage.getItem('cityName') || null);
  const [categoryDetails, setCategoryDetails] = useState<Category | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [userId, setUserId] = useState<string | null>(null);
  const [productId, setProductId] = useState<string | null>(null);
  const [productPrice, setProductPrice] = useState<string | null>(null);
  const [showproductPrice, setShowProductPrice] = useState<string | null>(null);
  const [catg_id, setCatId] = useState<string | null>(null);
  const [attributes, setAttributes] = useState<Attribute[]>([]);
  const [selectedAttributes, setSelectedAttributes] = useState<{ [key: number]: number | null }>({});
  const [selectedProductList, setSelectedProductList] = useState<string[]>([]);
  const [selectedProduct, setSelectedProduct] = useState<string | null>(null);
  const [brands, setBrands] = useState<Brand[]>([]);
  const [selectedBrand, setSelectedBrand] = useState<string | null>(null);
  const [slugSelected, setslugSelected] = useState<string | null>(null);
  const [qtyError, setqtyError] = useState<string | null>(null);
  const [unit, setUnit] = useState<string | null>('Unit');
  const [errorMessage, setErrorMessage] = useState('');
  const [errorBrand, seterrorBrand] = useState('');
  const [currentAttributeIndex, setCurrentAttributeIndex] = useState(0);
  const [isSubmitDisabled, setIsSubmitDisabled] = useState(true);
  const { refreshKey, setRefreshKey } = useRefresh();
  const { fetchCartQuantity, handleQuantity } = useCart();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [showFlashMessage, setShowFlashMessage] = useState(false);
  const handleOpenModal = () => {
    setIsModalOpen(true);
  };

  const {
    auth_token,
    user_id,
    city_name,
    sess_code,
    setcityName,
    setSessionCode,
    checkSessionTokenExpirationStatus,
    handleRemoveLocalStorage,
    utm_session_id,
    setUtmSessionId,
    globalUtmQueryRef,
    fetchCsrfToken
  } = useUser();
  const query = new URLSearchParams(location.search);
  const backendUrl = process.env.REACT_APP_BACKEND_URL;
  const version = process.env.REACT_APP_VERSION;
  const utmSource = query.get("utm_source");
  let utmQuery = location.state?.utmQuery
  utmQuery = utmQuery || ""
  let utmQueryRef: any = useRef("")
  function generateUtmSessionId(length = 24) {
    const characters =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    let result = "";

    for (let i = 0; i < length; i++) {
      const randomIndex = Math.floor(Math.random() * characters.length);
      result += characters[randomIndex];
    }

    return result;
  }

  useEffect(() => {
    const savecategoryId = sessionStorage.getItem('categoryId');
    if (!sess_code) {
      const code = sessionStorage.getItem('session_code') || generateSessionCode();

      sessionStorage.setItem('session_code', code);
      setSessionCode(code);
    }

    const login = localStorage.getItem("isLoggedIn")

    if (login === 'true') {
      showModal(true)
    }
    if (!productId) {
      setIsSubmitDisabled(true)
    }
    fetchPrice();
  }, [refreshKey]);

  useEffect(() => {
    if (!city_name) {
      setIsPopupVisible(true);
    }
    const storedUserId = localStorage.getItem('user_id'); // or fetch from context/API
    setUserId(storedUserId);
    if (utmSource) {
      // Usage
      const utmSessionId = generateUtmSessionId(); // Simple session ID generator
      setUtmSessionId(utmSessionId);
      // query.set('utm_session_id', utmSessionId); // Add utm_session_id to query
      // console.log("query set utm_session_id", query.toString());
      let utmquerydata = `${query.toString()}&utm_session_id=${utmSessionId}&full_utm_campaign_url=${window.location.href.replace(
        /&/g,
        ":<>:"
      )}`;
      utmQueryRef.current =
        globalUtmQueryRef.current = `${query.toString()}&utm_session_id=${utmSessionId}&full_utm_campaign_url=${window.location.href.replace(
          /&/g,
          ":<>:"
        )}`;
      localStorage.setItem(
        "utm_query_data",
        `${query.toString()}&utm_session_id=${utmSessionId}&full_utm_campaign_url=${window.location.href.replace(
          /&/g,
          ":<>:"
        )}`
      );
      // console.log(
      //   "query after setting utm_session_id",
      //   utmQueryRef.current
      // );
      createUtmTrackingSaveService(utmquerydata);
    } else {
      if (utmQuery) {
        // console.log("utm_query set in add to cart", utmQuery);
        utmQueryRef.current = utmQuery;
        globalUtmQueryRef.current = utmQuery;
        createUtmTrackingSaveService(utmQuery);
      }
    }
  }, []);

  // const FlashMessage: React.FC<FlashMessageProps> = ({ message, onClose }) => {
  //   useEffect(() => {
  //     const timer = setTimeout(() => {
  //       onClose(); // Hide the flash message after 5 seconds
  //     }, 5000);
  
  //     return () => clearTimeout(timer); // Cleanup on unmount
  //   }, [onClose]);
  
  //   return (
  //         <div
  //           style={{
  //             position: "fixed",
  //             top: "10px",
  //             left: "50%",
  //             transform: "translateX(-50%)",
  //             backgroundColor: "#db5f5f",
  //             color: "white",
  //             padding: "10px 20px",
  //             borderRadius: "5px",
  //             zIndex: 1000,
  //           }}
  //         >
  //           Session Expired. Please login to continue.
  //         </div>
  //       );
  // };

  const createUtmTrackingSaveService = async (utmData: any) => {
    try {
      // console.log("createUtmTrackingSaveService called", utmData);
      const response = await fetch(
        `${backendUrl}${version}utm-campaign-tracking?${utmData}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
           credentials: "include",
          mode: "cors"
        }
      );
      // console.log("createUtmTrackingSaveService called");
      const data = await response.json();
    } catch (err: any) {
      setError(err.message);
    } finally {
    }
  }

  const fetchSEOContent = async (cat_id: any) => {
    try {
      const response = await fetch(`${backendUrl}${version}seo-content-cat/${cat_id}`,
        {
          method: 'GET',
          headers: {
            // Accept:'aplication/json',
            "Content-Type": "application/json"

          },
          credentials: "include",
          mode: "cors"

        }
      );
      const data = await response.json();
      setSeoContent(data.data);
    } catch (err: any) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const sessio_code: string | null = sess_code;


  useEffect(() => {
    const savecategory = sessionStorage.getItem('categoryType');
    // // //console.log("category-type------", savecategory)

    // setselectedchildPro(savecategory)
    const savecategoryId = sessionStorage.getItem('categoryId');
    // categoryId
    if (savecategory == null) {
      setChildPro([])
      fetchChildCategory()
    } else {

      fetchChildDetails()
      // fetchAttributes(savecategoryId)
      const savedRequestData = JSON.parse(sessionStorage.getItem("requestData") || "{}");

      if (savedRequestData) {
        const { selectedBrand, attributes } = savedRequestData;

        // Set brand and attributes if they exist
        // if (selectedBrand) {
        //     setSelectedBrand(selectedBrand);
        // }

        // if (attributes) {
        //     setSelectedAttributes(attributes);
        // }
        // if (savecategory) {
        //     setselectedchildPro(savecategory)
        // }

        // //console.log("Saved Data: ", savedRequestData);
      }
    }

  }, []);

  // useEffect(() => {
  //     if (productPrice || isNaN(Number(showproductPrice))) {
  //     //   window.location.reload();
  //     }
  //   }, [showproductPrice]);


  // const handleAttributeChange = (attribute: string, value: any) => {
  //     setSelectedAttributes((prev) => ({
  //         ...prev,
  //         [attribute]: value,
  //     }));
  // };

  const allAttributesSelected = attributes.every(
    (attribute) => selectedAttributes[attribute.attribute_id] !== undefined
  );

  // const allAttributesSelected = attributes.every(
  //     (attribute: any) => selectedAttributes[attribute.attribute_id]
  // );
  // const isBrandSelected = Boolean(selectedBrand)
  // const initializeSessionCode = () => {
  //     let code = sessionStorage.getItem('session_code');
  //     if (!code) {
  //         code = generateSessionCode();
  //         sessionStorage.setItem('session_code', code);
  //     }
  //     setSessionCode(code);
  // };

  // Generate a session code
  const generateSessionCode = (): string => {
    return Math.random().toString(36).substr(2, 9);
  };
  useEffect(() => {

    const code = sessionStorage.getItem('session_code') || generateSessionCode();

    sessionStorage.setItem('session_code', code);
    setSessionCode(code);
    const initialize = async () => {
      try {
        // Generate cart
        const response = await fetch(`${backendUrl}api/v2/session-cart/${code}`,
          {
            method: 'GET',
            headers: {
              // Accept:'aplication/json',
              "Content-Type": "application/json"

            },
            credentials: "include",
            mode: "cors"

          }
        );

        const url = window.location.href;

      } catch (error) {
        //console.error('Error initializing:', error);
        setError('Failed to initialize');
      }
    };
    // Call the async function
    initialize();
  }, []);

  const fetchAttributes = async (catg_id: any) => {
    try {
      const response = await fetch(`${backendUrl}${version}product-attribute/${catg_id}`,
        {
          method: 'GET',
          headers: {
            // Accept:'aplication/json',
            "Content-Type": "application/json"

          },
          credentials: "include",
          mode: "cors"

        }
      );
      const data = await response.json();
      setAttributes(data.data.attributes);
      await changeTitleAndMetaTags(data.data.page_title, { description: data.data.page_seo.meta_description, keywords: data.data.page_seo.meta_tags })
    } catch (error) {
      //console.error("Error fetching attributes:", error);
    }
  };

  // Handle product selection (fetch products by category)
  const handleCategorySelect = async (catg_id: any) => {
    try {
      const response = await fetch(`${backendUrl}${version}All-product/${catg_id}`,
        {
          method: 'GET',
          headers: {
            // Accept:'aplication/json',
            "Content-Type": "application/json"

          },
          credentials: "include",
          mode: "cors"

        }
      );
      const data = await response.json();
      setSelectedProductList(data.data.productTitles);
    } catch (error) {
      //console.error('Error fetching products:', error);
      setError('Failed to load products');
    }
  };

  const handleClosePrice = () => {
    setShowModalNotExist(false)
    navigate('/sell-used-appliances')
    window.scrollTo({ top: 0, behavior: 'smooth' })
  };

  //   useEffect(() => {
  //     const priceValue = Number(showproductPrice ?? '0');
  //     if (priceValue === 0) {
  //       setShowModalNotExist(true);
  //     } else {
  //       setShowModalNotExist(false);
  //     }
  //   }, [showproductPrice]); // Dependency on `showproductPrice`


  const fetchDefaultPrice = async (cat_id: any) => {
    try {

      const response = await fetch(`${backendUrl}${version}product-default-price/${cat_id}`,
        {
          method: 'GET',
          headers: {
            // Accept:'aplication/json',
            "Content-Type": "application/json"

          },
          credentials: "include",
          mode: "cors"
        }
      );
      const data = await response.json();
      const fetchedPrice = data.data.productPrice;
      const unit = data.data.unittype
      setUnit(unit)
      // Set the product price quickly (no need to await here)
      setProductPrice(fetchedPrice);
      // //console.log("price0kkkkkkkkkk------", productPrice)
      setShowProductPrice(fetchedPrice);


      // setProductId(data.data.product_id);
    } catch (error) {
      //console.error("Error fetching attributes:", error);
    }
  };

  // Fetch brands based on category selection
  const handleBrandSelect = async (product: any, catg_id: any) => {
    setSelectedProduct(product);
    try {
      const response = await fetch(`${backendUrl}${version}brands/${catg_id}`,
        {
          method: 'GET',
          headers: {
            // Accept:'aplication/json',
            "Content-Type": "application/json"

          },
          credentials: "include",
          mode: "cors"

        }
      );
      const data = await response.json();

      setBrands(Array.isArray(data.data) ? data.data : []);
    } catch (error) {
      //console.error("Error fetching brands:", error);
      setError('Failed to load brands');
    }
  };

  // Handle attribute selection
  // const handleAttributeSelect = (attributeId: number, valueId: number) => {
  //     setSelectedAttributes((prev) => ({
  //         ...prev,
  //         [attributeId]: valueId,
  //     }));
  //     setCurrentAttributeIndex((prevIndex) => prevIndex + 1);
  // };

  const handleAttributeSelect = async (attributeId: number, valueId: number) => {
    // Update the selected attributes in state
    setSelectedAttributes((prev) => ({
      ...prev,
      [attributeId]: valueId,
    }));

    const savecategoryId = sessionStorage.getItem('categoryId');

    // Make an API call only for the first attribute
    if (!Object.keys(selectedAttributes).length) {
      try {
        const csrfToken = await fetchCsrfToken();
        const response = await fetch(`${backendUrl}${version}attribute-based/${savecategoryId}`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-CSRF-Token': csrfToken,
          },
          credentials: "include",
          body: JSON.stringify({
            attribute_id: attributeId,
            value_id: valueId,
          }),

        });

        const data: ApiResponse = await response.json();

        const attributesArray = data.data?.data; // Safely access the nested data

        if (Array.isArray(attributesArray)) {
          setAttributes(attributesArray);
        } else {
          //console.error("API response does not contain a valid 'data' array:", data);
        }
      } catch (error) {
        //console.error('Error hitting the API:', error);
      }
    }

  };


  // Automatically fetch price once both attributes and brand are selected
  useEffect(() => {
    if (selectedBrand && Object.keys(selectedAttributes).length === attributes.length) {
      setIsSubmitDisabled(false); // Enable the submit button when both are selected

      // fetchPrice();
    } else {
      // setIsSubmitDisabled(true);
    }
    if (checkSessionTokenExpirationStatus()) {
      // alert("Session token expired");
      // navigate("/");

      window.scrollTo({ top: 0, behavior: 'smooth' })
      handleRemoveLocalStorage()
    }
  }, [selectedBrand, selectedAttributes, attributes]);

  const FlashMessage: React.FC<FlashMessageProps> = ({ message, onClose }) => {
    useEffect(() => {
      const timer = setTimeout(() => {
        onClose(); // Hide the flash message after 5 seconds
      }, 3000);
  
      return () => clearTimeout(timer); // Cleanup on unmount
    }, [onClose]);
  
    return (
          <div
            style={{
              position: "fixed",
              top: "10px",
              left: "50%",
              transform: "translateX(-50%)",
              backgroundColor: "#db5f5f",
              color: "white",
              padding: "10px 20px",
              borderRadius: "5px",
              zIndex: 1000,
            }}
          >
           Session Expired. Please login to continue.
          </div>
        );
  };

  // Fetch price based on selected attributes and brand
  const showModal = async (value: any) => {
    //console.error("Error fetching cart items:111111111");
    const login = localStorage.getItem("isLoggedIn")

    if (login === 'true') {
      //console.error("Error fetching cart items:222222222222");
      setButtonName('Add To Cart')
      const val = true
      setshowAddModal(val)
      const requestData = {
        user_id,
        selectedProduct,
        selectedBrand,
        attributes: selectedAttributes, // Send selected attribute IDs
      };
      setShowProductPrice(productPrice)
      const priceFetch = 'true'
      const csrfToken = await fetchCsrfToken();
      const responsee = await fetch(
        `${backendUrl}api/v2/user-log/${user_id}/${sess_code}?priceFetch=${priceFetch}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "auth-token": `${auth_token}`,
            'X-CSRF-Token': csrfToken,
          },
          credentials: "include",
          body: JSON.stringify({
            product:productId,
            price:productPrice
          }),
          
        }
      );
      sessionStorage.setItem('requestData', JSON.stringify(requestData));
      //console.log("Brand:", productPrice, isSubmitDisabled, productId)
      setIsSubmitDisabled(false)

      const response = await fetch(`${backendUrl}${version}check-auth`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'auth-token': `${auth_token}`
        },
        credentials: "include",
        mode: "cors"
      });

      if (!response.ok) {
        //console.error("Error fetching cart items:4444444", response.status, response.statusText);

        // Handle 403 Forbidden explicitly
        if (response.status === 403) {
          localStorage.clear();
          sessionStorage.clear();
          setUserId(null)
          setIsButtonClicked(false);
          setShowFlashMessage(true);

          const modalElement: any = document.getElementById("exampleModalAddCart");

          if (modalElement) {
            const modalInstance = window.bootstrap.Modal.getInstance(modalElement); // Get the modal instance
            setButtonName('Login')

            if (modalInstance) {
              modalInstance.hide(); // Hide "Add to Cart" modal

              // Remove backdrop manually to avoid overlapping issues
              // document
              //     .querySelectorAll(".modal-backdrop")
              //     .forEach((backdrop) => backdrop.remove());

              // Ensure modal-related classes are removed
              modalElement.classList.remove("show");
              modalElement.setAttribute("aria-hidden", "true");
              modalElement.style.display = "none";
              setIsModalOpen(false);
            }
          }



          // ✅ Delay opening the login modal to ensure previous modal is closed
          setTimeout(() => {
            setTimeout(() => {
              setRefreshKey((prevKey: number) => prevKey + 1);
            }, 1000);
            const loginModalElement = document.getElementById("exampleModallogin");
            if (loginModalElement) {
              const loginModal = new window.bootstrap.Modal(loginModalElement);
              loginModal.show(); // Open the login modal
            }
          }, 1000);
          // Short delay (100ms) ensures the first modal closes properly

          // return;
        }

        // throw new Error(`HTTP error! Status: ${response.status}`);
      }
      if (productPrice && productId && response.ok) {
        setButtonName('Add To Cart')
        const modalElement = document.getElementById('exampleModalAddCart');
        if (modalElement) {
          const modal = new window.bootstrap.Modal(modalElement);
          modal.show(); // Open the modal
          setIsModalOpen(true);

        }
      }

    } else {
      setButtonName('Login')
      setshowAddModal(false)
      const requestData = {
        user_id,
        selectedProduct,
        selectedBrand,
        attributes: selectedAttributes, // Send selected attribute IDs
      };
      sessionStorage.setItem('requestData', JSON.stringify(requestData));

      const modalElement = document.getElementById('exampleModallogin');
      if (modalElement) {
        const modal = new window.bootstrap.Modal(modalElement);
        modal.show(); // Open the modal
      }

      // await fetchDefaultPrice(catg_id)

    }
  };

  const fetchPrice = async () => {

    const requestData = {
      user_id,
      selectedProduct,
      selectedBrand,
      attributes: selectedAttributes, // Send selected attribute IDs
    };
    sessionStorage.setItem('requestData', JSON.stringify(requestData))
    const savecategoryId = sessionStorage.getItem('categoryId');
    if (user_id) {

      try {

        const price = sessionStorage.getItem('productPrice');

        const prodid = sessionStorage.getItem('productId');
        //console.log("prod------------------", price, prodid)

        if (prodid && price) {
          setProductId(prodid);
          setProductPrice(price);
          setShowProductPrice(price)
        } else {

          await fetchDefaultPrice(catg_id)
        }

        // if (!data.data.productPrice) {
        //     // await fetchDefaultPrice(savecategoryId)
        // } 
      }
      catch (error) {
        //console.error('Error fetching price:', error);
        setError('Failed to fetch price');
      }
    } else {
      setButtonName('Login')
      // if (catg_id) {
      //     await fetchDefaultPrice(catg_id)
      // }

    }
  };

  // Handle the Add to Cart button click
  const handleAddToCart = async () => {
    if (isButtonClicked) return;

    setIsButtonClicked(true);

    if (!selectedBrand || !productId) return;
    const savedRequestData = JSON.parse(sessionStorage.getItem("requestData") || "{}");
    const ipResponse = await fetch("https://api.ipify.org?format=json");
    const ipData = await ipResponse.json();
    const ip_address = ipData.ip;

    const requestData = {
      user_id,
      product_id: productId,
      quantity: 1, // Default quantity is 1 for Add to Cart
      brand: selectedBrand,
      sess_code: sess_code,
      base_value: productPrice,
      ip_address:ip_address,
      attributes: savedRequestData
    };

    try {
      const csrfToken = await fetchCsrfToken();
      const response = await fetch(
        `${backendUrl}${version}add-to-cart?${utmQuery}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            'auth-token': `${auth_token}`,
            'X-CSRF-Token': csrfToken,
          },
          credentials: "include",
          body: JSON.stringify(requestData),

        }
      );
      const data = await response.json();

      if (!response.ok) {
        //console.error("Error fetching cart items:", response.status, response.statusText);
        // Handle 403 Forbidden explicitly
        if (response.status === 403) {
          localStorage.clear();
          sessionStorage.clear();
          setIsButtonClicked(false);
          setShowFlashMessage(true);
          const modalElement: any = document.getElementById("exampleModalAddCart");

          if (modalElement) {
            const modalInstance = window.bootstrap.Modal.getInstance(modalElement); // Get the modal instance

            if (modalInstance) {
              modalInstance.hide(); // Hide "Add to Cart" modal

              // Remove backdrop manually to avoid overlapping issues
              document
                .querySelectorAll(".modal-backdrop")
                .forEach((backdrop) => backdrop.remove());

              // Ensure modal-related classes are removed
              modalElement.classList.remove("show");
              modalElement.setAttribute("aria-hidden", "true");
              modalElement.style.display = "none";
              setIsModalOpen(false);
            }
          }

          // ✅ Delay opening the login modal to ensure previous modal is closed
          setTimeout(() => {
            const loginModalElement = document.getElementById("exampleModallogin");
            if (loginModalElement) {
              const loginModal = new window.bootstrap.Modal(loginModalElement);
              loginModal.show(); // Open the login modal
            }
          }, 100); // Short delay (100ms) ensures the first modal closes properly

          return;
        }

        throw new Error(`HTTP error! Status: ${response.status}`);
      }


      //console.log('Product added to cart:', data.data);
      if (data.data.addItem == false) {
        setqtyError("Maximum quantity reached to add this item in cart.")
        // sessionStorage.removeItem("requestData");
        // sessionStorage.removeItem("categoryType");
        // sessionStorage.removeItem('categoryId');
      } else {
        await handleCloseModal()
        navigate('/cart/listing', { state: { sess_code: sess_code, user_id: user_id, utmQuery } })
        window.scrollTo({ top: 0, behavior: 'smooth' })
        if (sessio_code) {
          await fetchCartQuantity(sessio_code)
        }
        sessionStorage.removeItem('productId');
        sessionStorage.removeItem("requestData");
        sessionStorage.removeItem("categoryType");
        sessionStorage.removeItem('categoryId');
      }

      setIsButtonClicked(true);
      // fetchCartQuantity(user_id); // Update cart quantity
    } catch (error) {
      //console.error('Error adding product to cart:', error);
    }
  };

  const fetchCategoryDetails = async (catg_id: any) => {
    try {
      const response = await fetch(`${backendUrl}${version}category-detail/${catg_id}`,
        {
          method: 'GET',
          headers: {
            // Accept:'aplication/json',
            "Content-Type": "application/json"

          },

          credentials: "include",
          mode: "cors"
        }
      );
      if (!response.ok) throw new Error('Failed to fetch categories');
      const data = await response.json();
      setCategoryDetails(data.data);
      if (data.data.parent_cat_id)
        // await setPriceDefault(data.data.productPrice,data.data.productPrice)
        await changeTitleAndMetaTags(data.data.page_title, { description: data.data.meta_description, keywords: data.data.meta_tags });
    } catch (error) {
      //console.error('Error fetching categories:', error);
    }
  };

  const changeTitleAndMetaTags = async (
    title: string,
    metaTags: { description?: string; keywords?: string;[key: string]: string | undefined }
  ) => {
    try {
      // Update the document title
      if (title) {
        document.title = title;
      } else {
        document.title = "Sell Used Appliances Online in India - Instant Cash & Free Pickup | Selsmart";
      }

      // Update or create meta tags
      Object.keys(metaTags).forEach((metaName) => {
        const metaTag = document.querySelector(`meta[name="${metaName}"]`);
        if (metaTag) {
          // Update existing meta tag
          metaTag.setAttribute('content', metaTags[metaName] || `Default ${metaName} for Selsmart`);
        } else {
          // Create new meta tag if it doesn't exist
          const newMetaTag = document.createElement('meta');
          newMetaTag.name = metaName;
          newMetaTag.content = metaTags[metaName] || `Default ${metaName} for Selsmart`;
          document.head.appendChild(newMetaTag);
        }
      });

      // Cleanup function to reset the title and meta tags when unmounting
      return () => {
        document.title = "Sell Used Appliances Online in India - Instant Cash & Free Pickup | Selsmart";
        Object.keys(metaTags).forEach((metaName) => {
          const metaTag = document.querySelector(`meta[name="${metaName}"]`);
          if (metaTag) {
            metaTag.setAttribute('content', `Default ${metaName} for Selsmart`);
          }
        });
      };
    } catch (error) {
      //console.error("Error updating title and meta tags:", error);
    }
  };



  const fetchChildCategory = async () => {
    const url = window.location.href;
    setqtyError(null)
    const commonPart = 'sell-';
    const slug = url.split(`${commonPart}`)[1];

    const urlPath = location.pathname; // Gets the pathname (e.g., "/sell-ac")

    if (!urlPath.startsWith('/sell-')) {
      navigate('*');
    }
    try {
      if (slug) {

        setslugSelected(`sell-${slug}`)
        const response = await fetch(`${backendUrl}${version}product-slug/sell-${slug}`,
          {
            method: 'GET',
            headers: {
              // Accept:'aplication/json',
              "Content-Type": "application/json"

            },
            credentials: "include",
            mode: "cors"

          }
        );
        const datas = await response.json();
        if (!datas.data.cat_id) {
          navigate('*')
        }
        await fetchDefaultPrice(datas.data.cat_id)
        await fetchSEOContent(datas.data.cat_id)
        await fetchCategoryDetails(datas.data.cat_id)

        settitleName(datas.data.title)
        setdefaultBanner(datas.data.listing_banner)

        const res = await fetch(`${backendUrl}${version}product-child/${datas.data.cat_id}`,
          {
            method: 'GET',
            headers: {
              // Accept:'aplication/json',
              "Content-Type": "application/json"

            },
            credentials: "include",
            mode: "cors"

          }
        );
        if (!res.ok) throw new Error('Failed to fetch categories');
        const data = await res.json();
        //console.log("title--------datttttttttttttttt---------", datas.data)
        if (productPrice == null && data.data.length == 0) {
          setShowModalNotExist(true);
        }
        if (!data.data) {


          setselectedchildPro(datas.data.title)
        }
        await setCatId(data.data.cat_id);
        if (data.data.cat_id != undefined) {
          await handleBrandSelect(data.data.cat_id, data.data.cat_id)
          await handleCategorySelect(data.data.cat_id);
          await fetchCategoryDetails(data.data.cat_id)
          await fetchAttributes(data.data.cat_id)
          await fetchSEOContent(data.data.cat_id)


        }

        // await fetchAttributes(data.data.cat_id)
        setChildPro(data.data);
      }

    } catch (error) {
      //console.error('Error fetching categories:', error);
      setError('Failed to load categoriessss');
    }
  };


  const fetchChildDetails = async () => {
    try {
      const url = window.location.href;
      const commonPart = 'sell-';
      const slug = url.split(`${commonPart}`)[1];
      const urlPath = location.pathname; // Gets the pathname (e.g., "/sell-ac")

      if (!urlPath.startsWith('/sell-')) {
        navigate('*');
      }
      setslugSelected(`sell-${slug}`)
      const response = await fetch(`${backendUrl}${version}product-slug/sell-${slug}`,
        {
          method: 'GET',
          headers: {
            // Accept:'aplication/json',
            "Content-Type": "application/json"

          },
          credentials: "include",
          mode: "cors"

        }
      );
      const datas = await response.json();
      if (!datas.data.cat_id) {
        navigate('*')
      }
      await fetchDefaultPrice(datas.data.cat_id)

      // if(priceFetched == null){
      //     setShowModalNotExist(true);
      // }
      const res = await fetch(`${backendUrl}${version}product-child/${datas.data.cat_id}`,
        {
          method: 'GET',
          headers: {
            // Accept:'aplication/json',
            "Content-Type": "application/json"

          },
          credentials: "include",
          mode: "cors"

        }
      );
      const data = await res.json();

      //console.log("dat03844444444444",productPrice , data.data == '[]')
      if (productPrice == null && data.data.length == 0) {
        setShowModalNotExist(true);
      }
      // //console.log("data----------", data.data)
      settitleName(datas.data.title)
      if (!data.data) {
        setselectedchildPro(datas.data.title)
      }
      setChildPro(data.data);
      await fetchCategoryDetails(datas.data.cat_id);
      await fetchSEOContent(datas.data.cat_id)
    } catch (error) {
      //console.error('Error fetching categories:', error);
      setError('Failed to load categoriesd');
    }
  };

  const handleCategoryClick = async (selectedCategory: any, catTitle: any) => {
    //console.log("898988888888888dddddddddddd", selectedCategory)
    sessionStorage.removeItem('productId');
    sessionStorage.setItem('categoryType', catTitle);
    sessionStorage.setItem('categoryId', selectedCategory);
    // Reset attributes and other states before fetching new data
    setAttributes([]); // Clear existing attributes
    setSelectedAttributes({}); // Reset selected attribute values
    setCurrentAttributeIndex(0); // Start with the first attribute

    try {
      setCatId(selectedCategory);
      await handleBrandSelect(selectedCategory, selectedCategory);
      await handleCategorySelect(selectedCategory);
      await fetchCategoryDetails(selectedCategory);
      await fetchAttributes(selectedCategory); // Fetch attributes only once

    } catch (error) {
      //console.error("Error in handleCategoryClick:", error);
    }
  };

  // const setPriceDefault =async (price:any,id:any) => {

  //     setProductId(id)
  //     setProductPrice(price)
  // }
  // const handleSellNowClick = async () => {
  //     const returnUrl = 'product-detail';
  //     if (!user_id || user_id == null) {
  //         // handleQuicksellButton()
  //         navigate('/login', { state: { returnUrl, user_id: user_id, session_code: sess_code, productId: productId, slug: slugSelected } });
  //         window.scrollTo({ top: 0, behavior: 'smooth' })
  //     } else {
  //         // handleQuicksellButton()
  //         sessionStorage.removeItem("requestData");
  //         navigate('/order-summary', { state: { returnUrl, user_id: user_id, session_code: sess_code, productId: productId } });
  //         window.scrollTo({ top: 0, behavior: 'smooth' })
  //     }
  // };
  const handleDetectLocation = async () => {
    if (!navigator.geolocation) {
      alert('Geolocation is not supported by your browser.');
      return;
    }

    setIsLoading(true); // Start loading spinner
    navigator.geolocation.getCurrentPosition(
      async (position) => {
        const { latitude, longitude } = position.coords;
        const apiKey = 'AIzaSyCO66yKQ63AX-lQmhU7bRUiRkbpGP9nGeU'; // Google Maps API key

        try {
          const responseGoogle = await fetch(
            `https://maps.googleapis.com/maps/api/geocode/json?latlng=${latitude},${longitude}&key=${apiKey}`
          );
          const data = await responseGoogle.json();

          if (data.status !== 'OK' || !data.results[0]) {
            throw new Error('Unable to fetch location details.');
          }

          const addressComponents = data.results[0].address_components;
          const city = addressComponents.find((component: any) =>
            component.types.includes('locality') || component.types.includes('administrative_area_level_1')
          )?.long_name || 'Unknown city';

          const state = addressComponents.find((component: any) =>
            component.types.includes('administrative_area_level_1')
          )?.long_name || 'Unknown state';

          const pincode = addressComponents.find((component: any) =>
            component.types.includes('postal_code')
          )?.long_name || 'Unknown pincode';

          // //console.log('Pincode:', pincode);

          // Fetch city and state data by pincode from backend
          const pincodeResponse = await fetch(`${backendUrl}api/v2/pincode/${pincode}`,
            {
              method: 'GET',
              headers: {
                // Accept:'aplication/json',
                "Content-Type": "application/json"

              },
              credentials: "include",
              mode: "cors"

            }
          );
          if (pincodeResponse.ok) {
            const pincodeData = await pincodeResponse.json();
            if (pincodeData?.data?.city) {
              const cityName = pincodeData.data.city;
              const stateName = pincodeData.data.state;

              // Set city and state
              setcityName(cityName);
              sessionStorage.setItem('cityName', cityName);
              sessionStorage.setItem('stateName', stateName);

              // Close the popup after successful city detection
              setIsPopupVisible(false);
            } else {
              alert('City data not available for the detected pincode.');
            }
          } else {
            alert('Failed to fetch city data by pincode.');
          }
        } catch (error) {
          alert('Failed to fetch location. Please try again.');
        } finally {
          setIsLoading(false); // Stop loading spinner
        }
      },
      () => {
        alert('Failed to fetch location. Please enable location access.');
        setIsLoading(false); // Stop loading spinner
      }
    );
  };

  const handleCloseModal = () => {
    setIsButtonClicked(false);
    const modalElement: any = document.getElementById("exampleModalAddCart");
    // //console.log("modalElement: ", modalElement)
    const modalInstance = Modal.getInstance(modalElement); // Get the modal instance
    // //console.log("modalInstance: ", modalInstance);

    if (modalInstance) {
      modalInstance.hide(); // Hides the modal
      document
        .querySelectorAll(".modal-backdrop")
        .forEach((backdrop) => backdrop.remove());

      // Ensure modal-related classes are removed
      modalElement.classList.remove("show");
      modalElement.setAttribute("aria-hidden", "true");
      modalElement.style.display = "none";
      setIsModalOpen(false);

    }

  };
  const handleRefresh = () => {
    setRefreshKey((prevKey: any) => prevKey + 1);
  };

  // //console.log("{!Number(productPrice) || Number(productPrice) <= 0 || isSubmitDisabled || !Number(productId)}",!Number(productPrice) || Number(productPrice) <= 0 || isSubmitDisabled || !Number(productId),productPrice,isSubmitDisabled,productId)

  useEffect(() => {
    // Automatically set the default value if only one option is available
    if (childPro.length === 1) {
      const defaultOption = childPro[0];
      setselectedchildPro(defaultOption.title); // Set the selected category
      handleCategoryClick(defaultOption.cat_id, defaultOption.title); // Trigger any required actions
    }
  }, [childPro]);

  useEffect(() => {
    if (showAddModalNotExist) {
      disableBodyScroll(); // Disable body scrolling when modal opens
    } else {
      enableBodyScroll(); // Enable body scrolling when modal closes
    }

    // Cleanup to re-enable scrolling if component unmounts
    return () => enableBodyScroll();
  }, [showAddModalNotExist]);

  const modalStyles: { overlay: React.CSSProperties; modal: React.CSSProperties; button: React.CSSProperties } = {
    overlay: {
      position: 'fixed', // Valid string for 'position'
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      zIndex: 9999,
    },
    modal: {
      backgroundColor: 'white',
      padding: '40px',
      borderRadius: '8px',
      textAlign: 'center',
      overflow: 'hidden'
    },
    button: {
      padding: '5px',
      margin: '8px',
    }
  };

  const disableBodyScroll = () => {
    document.body.style.overflow = 'hidden'; // Disable scrolling on body when modal is open
  };

  const enableBodyScroll = () => {
    document.body.style.overflow = 'auto'; // Enable scrolling on body when modal is closed
  };

  return (
    <div>
      <Header />
      {showFlashMessage && <FlashMessage message={error ?? ""} onClose={() => setShowFlashMessage(false)} />}
      {isPopupVisible && (
        <CityPopup
          onClose={() => setIsPopupVisible(false)}
          onFetchLocation={handleDetectLocation}
          onCitySelected={(cityName) => {
            setCityName(cityName);
            sessionStorage.setItem("cityName", cityName);
          }}
        />
      )}
      <div className="section_breadcrumb">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <ul className="breadcrumb">
                <li className="breadcrumb-item"><a href="/">Home</a></li>
                <li className="breadcrumb-item"><a href="/sell-used-appliances">Sell Now</a></li>
                <li className="breadcrumb-item active" aria-current="page">
                  {titleName
                    ? titleName.charAt(0).toUpperCase() + titleName.slice(1).toLowerCase()
                    : ""}
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <section className='banner_product'>
        <div className='container'>
          <div className='row'>
            <div className="col-md-12">
              {categoryDetails?.listing_banner ? (
                <img className='web_view_banner'
                  src={
                    categoryDetails?.listing_banner
                  }
                  alt={categoryDetails?.title}
                />


              ) : null}
              {categoryDetails?.mobile_listing_banner ? (
                <img className='mob_viwe_banner'
                  src={
                    categoryDetails?.mobile_listing_banner
                  }
                  alt={categoryDetails?.title}
                />


              ) : null}
            </div>

          </div>
        </div>
      </section>
      <section className="sell_now_sub_cate">
        <div className="container">
          <div className="row">
            <div className="image-box col-md-3 text-center">
              {categoryDetails?.logo_img ? (
                <img
                  src={
                    categoryDetails?.logo_img
                  }
                  alt={categoryDetails.title}
                />
              ) : (<img
                src={
                  productImage
                }
                alt={categoryDetails?.title}
              />)}
              {/* <img
                                src={`./${categoryDetails?.listing_banner}`}
                                alt={categoryDetails?.title}
                                onError={(e: any) => {
                                    e.target.onerror = null;
                                    e.target.src = productImage;
                                }}
                            /> */}
            </div>
            <div className="info-box col-md-4">
              <h1>{titleName}</h1>

              <div className="select_input_wrap mb-3">
                <label className="form-label">
                  Category
                  <span style={{ color: "red" }}>*</span>
                </label>

                {selectedchildPro &&
                  childPro.some((brand: any) => brand.title === selectedchildPro && (brand.parent_cat_id === 9 || brand.parent_cat_id === 12)) ? (
                  // If the selected category is excluded, show it as plain text (no dropdown)
                  <div className="form-select">
                    {selectedchildPro} {/* Display preselected category */}
                  </div>
                ) : (
                  // Render the dropdown
                  <select
                    value={selectedchildPro || ""} // Ensure it reflects the selected value
                    onChange={(e) => {
                      const selectedOption = e.target.options[e.target.selectedIndex];
                      const cat_id = selectedOption.getAttribute("data-cat_id"); // Extract cat_id
                      const title = selectedOption.getAttribute("data-title"); // Extract title
                      setqtyError(null);
                      setIsButtonClicked(false);
                      fetchSEOContent(cat_id)
                      setselectedchildPro(title); // Set the selected title
                      handleCategoryClick(Number(cat_id), title); // Pass both cat_id and title
                    }}
                    className="form-select"
                  >
                    <option value="" disabled>
                      {"Select Category"}
                    </option>

                    {/* Render remaining options excluding parent_cat_id 9 and 12 */}
                    {childPro.length > 0 &&
                      childPro
                        .filter((brand: any) => brand.parent_cat_id !== 9 && brand.parent_cat_id !== 12) // Filter out parent_cat_id 9 or 12
                        .map((brand) => (
                          <option
                            key={brand.cat_id}
                            value={brand.title} // Match the `value` to `selectedchildPro`
                            data-cat_id={brand.cat_id}
                            data-title={brand.title}
                          >
                            {brand.title}
                          </option>
                        ))}
                  </select>
                )
                }

                {error && <p style={{ color: "red" }}>{error}</p>}
              </div>





              {Array.isArray(attributes) &&
                attributes.map((attribute, index) => {
                  const isSaved = selectedAttributes[attribute.attribute_id] !== undefined;
                  const shouldShow =
                    isSaved ||
                    index === 0 ||
                    selectedAttributes[attributes[index - 1]?.attribute_id] !== undefined;

                  if (!shouldShow) return null;

                  // Declare async function to handle attribute selection
                  const handleAttributeSelect = async (attributeId: any, value: any) => {
                    // Update the selected attributes state with the selected value

                    setSelectedAttributes((prevState) => ({
                      ...prevState,
                      [attributeId]: value,
                    }));
                    //console.log("---------attributes-selected------", selectedAttributes)

                    // Trigger the API request if it's the first attribute selected
                    if (index === 0 && value) {
                      const savecategoryId = sessionStorage.getItem('categoryId') || ''; // Fix the categoryId retrieval
                      try {
                        // Call your API here, for example:
                        const csrfToken = await fetchCsrfToken();
                        const response = await fetch(`${backendUrl}${version}attribute-based/${savecategoryId}/${city_name}`, {
                          method: 'POST',
                          headers: {
                            'Content-Type': 'application/json',
                            'X-CSRF-Token': csrfToken,
                          },
                          credentials: "include",
                          body: JSON.stringify({
                            attribute_id: attributeId,
                            value_id: value,
                          }),

                        });

                        // Check if the response was successful
                        if (!response.ok) {
                          throw new Error('Network response was not ok');
                        }

                        // Await the response and parse it
                        const data = await response.json();

                        // Safely access the nested data
                        const attributesArray = data.data?.data;
                        setqtyError(null)

                        if (data.data?.data == undefined) {
                          // sessionStorage.removeItem("requestData");
                          await setSelectedBrand(null)
                          seterrorBrand('Please select brand')
                          setIsSubmitDisabled(true)
                          fetchAttributes(savecategoryId)
                          setCatId(savecategoryId)
                          if (user_id) {
                            setProductId(data.data.productId);
                            setProductPrice(data.data.product_price);
                          } else {
                            fetchPrice()
                          }

                          sessionStorage.setItem('productPrice', data.data.product_price);
                          sessionStorage.setItem('productId', data.data.productId);
                        }
                        setProductId(data.data.productId);
                        setProductPrice(data.data.product_price);
                        // If valid, set attributes state with the new data
                        if (Array.isArray(attributesArray)) {
                          setAttributes(attributesArray);
                          //console.log("---------dta-------", attributesArray)
                          await setSelectedBrand(null)
                          seterrorBrand('Please select brand')
                          if (user_id) {
                            setProductId(data.data.productId);
                            setProductPrice(data.data.product_price);
                          } else {
                            fetchPrice()
                          }
                          sessionStorage.setItem('productPrice', data.data.product_price);
                          sessionStorage.setItem('productId', data.data.productId);
                          setIsSubmitDisabled(true)
                          // fetchPrice();

                        } else {

                          //console.error("API response does not contain a valid 'data' array:", data);
                        }
                      } catch (error) {
                        //console.error("Error fetching data:", error);
                      }
                    }
                  };

                  return (
                    <div key={attribute.attribute_id} className="select_input_wrap mb-3">
                      <label className="form-label">
                        {attribute.title}
                        <span style={{ color: 'red' }}>*</span>
                      </label>
                      <select
                        value={selectedAttributes[attribute.attribute_id] || ''}
                        onChange={(e) =>
                          handleAttributeSelect(attribute.attribute_id, Number(e.target.value))
                        }
                        className="form-select"
                      >
                        <option value="" disabled>
                          Select {attribute.title}
                        </option>
                        {attribute.values.map((value) => (
                          <option key={value.id} value={value.id}>
                            {value.value}
                          </option>
                        ))}
                      </select>
                    </div>
                  );
                })}

              {allAttributesSelected && brands.length > 0 && (
                <div className="select_input_wrap mb-3">
                  <label className="form-label">
                    Brand<span style={{ color: 'red' }}>*</span>
                  </label>
                  <select
                    value={selectedBrand || ''}
                    onChange={(e) => {
                      setSelectedBrand(e.target.value); // Update the selected brand
                      if (user_id) {
                        // console.log("------>>>>>>>>>>price----", showproductPrice, productPrice)
                        setShowProductPrice(productPrice);
                      }
                      // Update product price
                      showModal(true); // Show the modal
                      setIsButtonClicked(false);
                    }}
                    className="form-select"
                  >
                    <option value="" disabled>
                      Select Brand
                    </option>
                    {brands.map((brand, index) => (
                      <option key={index} value={brand.title}>
                        {brand.title}
                      </option>
                    ))}
                  </select>

                  {selectedBrand == null ? (
                    <p className="error-message" style={{ color: 'red', marginTop: '10px' }}>
                      {errorBrand}
                    </p>
                  ) : (
                    <p className="error-message" style={{ color: 'red', marginTop: '10px' }}></p>
                  )}
                </div>
              )}
              {/* {allAttributesSelected && (
                                <div className="select_input_wrap mb-3">
                                    <label className="form-label">
                                        Brand<span style={{ color: 'red' }}>*</span>
                                    </label>
                                    <select
                                        value={selectedBrand || ''}
                                        // onChange={(e) => setSelectedBrand(e.target.value)}
                                        onChange={(e) => {
                                            setSelectedBrand(e.target.value); // Update the selected brand
                                            setShowProductPrice(productPrice)
                                            showModal(true)    // Call the fetchPrice function with the selected value

                                        }}
                                        className="form-select"
                                    >
                                        <option value="" disabled>
                                            Select Brand
                                        </option>
                                        {brands.length > 0 ? (
                                            brands.map((brand, index) => (
                                                <option key={index} value={brand.title}>
                                                    {brand.title}
                                                </option>
                                            ))
                                        ) : (
                                            <option value="Others"></option>
                                        )}
                                    </select>

                                    {selectedBrand == null ?  (
                                        <p className="error-message" style={{ color: 'red', marginTop: '10px' }}>
                                            {errorBrand}
                                        </p>
                                    ):(
                                        <p className="error-message" style={{ color: 'red', marginTop: '10px' }}>
                                        
                                    </p>  
                                    )}
                                </div>
                            )} */}
            </div>

            <div className={`price-box col-md-4 ${isModalOpen ? 'hidden_price_div' : ''}`}
              key={refreshKey}>
              {showproductPrice === undefined || showproductPrice === null || isNaN(Number(showproductPrice)) ? (
                <p className="price"></p>  // Show a loading message instead of hiding the price
              ) : (
                user_id ? (
                  <p className="price">
                    ₹ {Number(showproductPrice)}
                    <span> per {unit}</span>
                  </p>
                ) : (
                  <p className="price">
                    <span>Up to </span>₹ {Number(showproductPrice)}
                  </p>
                )
              )}



              <p className="pickup-fee">Excluding pickup fee</p>
              <input type="text" id="coupon-code" placeholder="eg: DAIKIN321" />
              <button className="apply-btn">Apply</button>

              <div key={refreshKey}>
                {user_id ? (
                  <div className="product-action-buttons" >
                    <button
                      className={`add-cart-btn ${qtyError ? 'disabled-btn' : ''}`}
                      onClick={handleAddToCart}
                      disabled={
                        !!qtyError || // Disable when qtyError exists
                        !Number(productPrice) ||
                        Number(productPrice) <= 0 ||
                        isSubmitDisabled ||
                        !Number(productId)
                      }
                      style={{
                        backgroundColor: qtyError ? '#b3b3b3' : '', // Set background color to grey when disabled
                        cursor: qtyError ? 'not-allowed' : '', // Change cursor to indicate disabled state
                      }}
                    >
                      {buttonName}
                    </button>
                    {qtyError && (
                      <p className="error-message" style={{ color: 'red', marginTop: '10px' }}>
                        {qtyError}
                      </p>
                    )}
                  </div>
                ) : (
                  <>
                    {errorMessage && (
                      <p className="error-message" style={{ color: 'red', marginTop: '10px' }}>
                        {errorMessage}
                      </p>
                    )}
                    <button
                      className="login-btn"
                      data-bs-toggle="modal"
                      data-bs-target="#exampleModallogin"

                      disabled
                    >
                      {buttonName}
                    </button>
                    <p className="exact-value">
                      <span style={{ color: 'red' }}>*</span>
                      <span style={{ color: 'red' }}>*</span>To get Exact Value.
                    </p>
                  </>
                )}
              </div>

            </div>


            <div className={`price-box condition_button d-none col-md-4 ${isModalOpen ? 'mobile_visible_hidden' : ''}`}>

              {productPrice === undefined || productPrice === null || isNaN(Number(productPrice)) ? (
                <p className="price"></p>  // Show loading instead of hiding
              ) : (
                user_id ? (
                  <p className="price">
                    ₹ {Number(productPrice)}
                    <span> per unit</span>
                  </p>
                ) : (
                  <p className="price">
                    <span>Up to </span>₹ {Number(productPrice)}
                  </p>
                )
              )}

              {user_id ? (
                <div className="product-action-buttons">
                  <button
                    className={`add-cart-btn ${qtyError ? 'disabled-btn' : ''}`}
                    onClick={handleAddToCart}
                    disabled={
                      !!qtyError || // Disable when qtyError exists
                      !Number(productPrice) ||
                      Number(productPrice) <= 0 ||
                      isSubmitDisabled ||
                      !Number(productId)
                    }
                    style={{
                      backgroundColor: qtyError ? '#b3b3b3' : '', // Set background color to grey when disabled
                      cursor: qtyError ? 'not-allowed' : '', // Change cursor to indicate disabled state
                    }}
                  >
                    {buttonName}
                  </button>
                  {qtyError && (
                    <p className="error-message" style={{ color: 'red', marginTop: '10px' }}>
                      {qtyError}
                    </p>
                  )}

                </div>
              ) : (
                <>
                  {errorMessage && (
                    <p className="error-message" style={{ color: 'red', marginTop: '10px' }}>
                      {errorMessage}
                    </p>
                  )}
                  <button
                    className="login-btn"
                    // onClick={handleLoginRedirect}
                    data-bs-toggle="modal" data-bs-target="#exampleModallogin"
                  >
                    {buttonName}
                  </button>
                  <p className='exact-value fixed_txt'><span style={{ color: 'red' }}>*</span><span style={{ color: 'red' }}>*</span>To get Exact Value.</p>


                </>
              )}
            </div>


          </div>

        </div>

      </section>
      {/* <!-- Button trigger modal --> */}

      {/* <!-- Modal --> */}
      <div className="modal fade sub_cat_pop" id="exampleModal" tabIndex={-1} aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header" style={{ borderBottom: "0 none" }}>
              {/* <h1 className="modal-title fs-5" id="exampleModalLabel">Modal title</h1> */}
              <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div className="modal-body">
              <div className="price-box col-md-12">
                {productPrice === undefined || productPrice === null || isNaN(Number(productPrice)) ? (
                  <p className="price"></p>  // Show a loading message instead of hiding
                ) : (
                  user_id ? (
                    <p className="price">
                      ₹ {Number(productPrice)}
                      <span> per unit</span>
                    </p>
                  ) : (
                    <p className="price">
                      <span>Up to </span>₹ {Number(productPrice)}
                    </p>
                  )
                )}



                <p className="pickup-fee">Excluding pickup fee</p>
                <input type="text" id="coupon-code" placeholder="eg: DAIKIN321" />
                <button className="apply-btn">Apply</button>
                {user_id ? (
                  <div className="product-action-buttons">
                    <button
                      className={`add-cart-btn ${qtyError ? 'disabled-btn' : ''}`}
                      onClick={handleAddToCart}
                      disabled={
                        !!qtyError || // Disable when qtyError exists
                        !Number(productPrice) ||
                        Number(productPrice) <= 0 ||
                        isSubmitDisabled ||
                        !Number(productId)
                      }
                      style={{
                        backgroundColor: qtyError ? '#b3b3b3' : '', // Set background color to grey when disabled
                        cursor: qtyError ? 'not-allowed' : '', // Change cursor to indicate disabled state
                      }}
                    >
                      {buttonName}
                    </button>
                    {qtyError && (
                      <p className="error-message" style={{ color: 'red', marginTop: '10px' }}>
                        {qtyError}
                      </p>
                    )}
                    {/* <button
                                        className="quick-sell-btn"
                                        onClick={handleSellNowClick}
                                        disabled={!Number(productPrice) || Number(productPrice) <= 0 || isSubmitDisabled || !Number(productId)}
                                    >
                                        Quick Sell
                                    </button> */}
                  </div>
                ) : (
                  <>
                    {errorMessage && (
                      <p className="error-message" style={{ color: 'red', marginTop: '10px' }}>
                        {errorMessage}
                      </p>
                    )}
                    <button
                      className="login-btn"
                    // onClick={handleLoginRedirect}
                    // disabled={!allAttributesSelected || !isBrandSelected}
                    >
                      {buttonName}
                    </button>
                    <p className='exact-value'><span style={{ color: 'red' }}>*</span><span style={{ color: 'red' }}>*</span>To get Exact Value.</p>

                  </>
                )}
              </div>
            </div>
            <div className="modal-footer" style={{ display: "none" }}>
              <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Close</button>
              <button type="button" className="btn btn-primary">Save changes</button>
            </div>
          </div>
        </div>
      </div>
      <div
        className="modal fade login_popup"
        id="exampleModallogin"
        tabIndex={-1}
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
        data-bs-backdrop="static" // Prevent closing when clicking outside
        data-bs-keyboard="false" // Optional: Prevent closing with the Escape key
      >
        <div className="modal-dialog modal-dialog-centered custom-modal-size ">
          <div className="modal-content">
            <div className="modal-header" style={{ borderBottom: 'none' }}>
            </div>

            <div className="modal-body modalbodyremoves text-center">
              <PopupLogin utmQuery={utmQueryRef.current} />
            </div>
          </div>
        </div>
      </div>
      <div
        className="modal fade addCart_popup"
        id="exampleModalAddCart"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
        tabIndex={-1}
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered custom-modal-size sdfsdfsd">
          <div className="modal-content">
            <div className="modal-header" style={{ borderBottom: 'none' }}>
              <button
                type="button"
                className="btn-close"
                onClick={handleCloseModal}  // This should also work when you manually call handleCloseModal
                data-bs-dismiss="modal"
                aria-label="Close"
              />
            </div>
            <div className="modal-body text-center">
              <p className='icon_cart'>
                <img src={cartIcon} alt='Cart' />
              </p>
              {productPrice === undefined || productPrice === null || isNaN(Number(productPrice)) ? (
                <p className="price"></p>  // Show loading instead of hiding
              ) : (
                user_id ? (
                  <p className="price-modal">
                    ₹ {Number(productPrice)}
                    <span> per unit</span>
                  </p>
                ) : (
                  <p className="price">
                    <span>Up to </span>₹ {Number(productPrice)}
                  </p>
                )
              )}



              <p className="pickup-fee-modal">Excluding pickup fee</p>
              <button
                className={`add-cart-btn ${qtyError ? 'disabled-btn' : ''}`}
                onClick={handleAddToCart}
                disabled={
                  !!qtyError || // Disable when qtyError exists
                  !Number(productPrice) ||
                  Number(productPrice) <= 0 ||
                  isSubmitDisabled ||
                  !Number(productId) ||
                  isButtonClicked // Disable when button is clicked
                }
                style={{
                  backgroundColor: qtyError ? '#b3b3b3' : '', // Set background color to grey when disabled
                  cursor: qtyError ? 'not-allowed' : '', // Change cursor to indicate disabled state
                }}
              >
                Add to Cart
              </button>
              {qtyError && (
                <p className="error-message" style={{ color: 'red', marginTop: '10px' }}>
                  {qtyError}
                </p>
              )}
            </div>
          </div>
        </div>
      </div>
      <div className="container">
        <div className='seo-content' dangerouslySetInnerHTML={{ __html:seoContent || ""}}></div>
      </div>

      {showAddModalNotExist && (
        <div className="popup_cart" style={modalStyles.overlay}>
          <div style={modalStyles.modal}>
            {/* <FontAwesomeIcon className="cart-empty" icon={faShoppingCart} /> */}
            <p className="cart-empty-msg">
              Product does not exist. Please select another product.
            </p>
            <button
              className="cart-empty-button"
              onClick={handleClosePrice}
            >
              Got it
            </button>
          </div>
        </div>
      )}
      <Footer />
    </div>
  );
};

export default ProductDetailPageSame;

{/* <div className="modal-body modalbodyremoves text-center">
{user_id ? (

  <div className="add-to-cart-popup">
    <h2>Item Added to Cart</h2>
    <p>Your item has been successfully added to the cart.</p>
    <button className="close-btn">Close</button>
  </div>
) : (

  <PopupLogin />
)}
</div>  */}